/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Group_TimelineInputs */

const en_shortcut_keys_group_timeline = /** @type {(inputs: Shortcut_Keys_Group_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeline`)
};

const fr_shortcut_keys_group_timeline = /** @type {(inputs: Shortcut_Keys_Group_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeline`)
};

const de_shortcut_keys_group_timeline = /** @type {(inputs: Shortcut_Keys_Group_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitleiste`)
};

const it_shortcut_keys_group_timeline = /** @type {(inputs: Shortcut_Keys_Group_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronologia`)
};

const ru_shortcut_keys_group_timeline = /** @type {(inputs: Shortcut_Keys_Group_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хронология`)
};

const es_shortcut_keys_group_timeline = /** @type {(inputs: Shortcut_Keys_Group_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronología`)
};

const zh_cn2_shortcut_keys_group_timeline = /** @type {(inputs: Shortcut_Keys_Group_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间线`)
};

const ja_shortcut_keys_group_timeline = /** @type {(inputs: Shortcut_Keys_Group_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムライン`)
};

const hi_shortcut_keys_group_timeline = /** @type {(inputs: Shortcut_Keys_Group_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय`)
};

const pt_pt2_shortcut_keys_group_timeline = /** @type {(inputs: Shortcut_Keys_Group_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linha do tempo`)
};

/**
* | output |
* | --- |
* | "Timeline" |
*
* @param {Shortcut_Keys_Group_TimelineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_group_timeline = /** @type {((inputs?: Shortcut_Keys_Group_TimelineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Group_TimelineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_group_timeline(inputs)
	if (locale === "de") return de_shortcut_keys_group_timeline(inputs)
	if (locale === "it") return it_shortcut_keys_group_timeline(inputs)
	if (locale === "ru") return ru_shortcut_keys_group_timeline(inputs)
	if (locale === "es") return es_shortcut_keys_group_timeline(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_group_timeline(inputs)
	if (locale === "ja") return ja_shortcut_keys_group_timeline(inputs)
	if (locale === "hi") return hi_shortcut_keys_group_timeline(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_group_timeline(inputs)
	return en_shortcut_keys_group_timeline(inputs)
});